import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MapboxComponent } from './components/mapbox/mapbox.component';
import { QmPipesModule } from '../../../components/qm-pipes/qm-pipes.module';
import { InlineSVGModule } from 'ng-inline-svg';
import { MapboxDirectionsComponent } from './components/mapbox-directions/mapbox-directions.component';
import { MarkerComponent } from '../components/marker/marker.component';
import { HoverComponent } from '../components/hover/hover.component';
import { OverlayPanelModule } from '../../../components/overlay-panel/overlay-panel.module';
import { VrgroupModule } from '../../../custom/vrgroup/vrgroup.module';
import { QmDirectivesModule } from '../../../components/qm-directives/qm-directives.module';
import { SharedProviderModule } from '../../shared.module';
import { ElementDetailsModule } from '../../../element-details/element-details.module';
import { TrainInfoModule } from '../../../custom/vrgroup/train-info/train-info.module';
import { ElementUtilsModule } from '../../../element-utils/element-utils.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FluentInfoModule } from '~app/custom/joensuu/fluent/fluent-info.module';
import { V2LInfoModule } from '~app/v2l/hover/v2l-info.module';

@NgModule({
  imports: [
    CommonModule,
    SharedProviderModule,
    QmPipesModule,
    QmDirectivesModule,
    VrgroupModule,
    TrainInfoModule,
    FluentInfoModule,
    V2LInfoModule,
    ElementDetailsModule,
    OverlayPanelModule,
    ElementUtilsModule,
    FontAwesomeModule,
    InlineSVGModule.forRoot()
  ],
  providers: [
  ],
  declarations: [
    MapboxComponent,
    MapboxDirectionsComponent,
    MarkerComponent,
    HoverComponent,
  ],
  exports: [
    MapboxComponent,
    MapboxDirectionsComponent
  ]
})
export class MapboxModule { }
